var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _g2, _path13, _path14, _path15, _path16, _g3, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 526,
    height: 326,
    fill: "none",
    v: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M476.843 302.508h-223.94V171.7l-1.029-.659 36.35-35.243c18.374-17.877 42.993-27.969 68.685-28.158l66.823-.608.096.114 53.171 62.967-.157 1.743.001 130.652z",
    fill: "#f5f4f8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M429.013 131.715H295.081v1.261h133.932v-1.261zm-13.301 13.239H281.78v1.261h133.932v-1.261zm77.854 86.679H469.22v21.42h24.346v-21.42zm0-37.075H469.22v21.08h24.346v-21.08z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M462.257 109.153h-21.831v75.212h21.831v-75.212z",
    fill: "#efecf3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M476.844 302.507H357.002v-86.685a84.12 84.12 0 0 1 20.248-54.688l46.391-54.14 53.203 63.048v132.465z",
    fill: "#d5d2dc",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M437.611 237.317h-24.345v21.421h24.345v-21.421zm0-37.076h-24.345v21.081h24.345v-21.081zm-116.289 31.392h-24.345v21.42h24.345v-21.42zm0-37.075h-24.345v21.08h24.345v-21.08z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M287.653 67.891h-26.492v91.288h26.492V67.891z",
    fill: "#efecf3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M305.291 302.507H33.62V143.774L32.412 143l.285-.277 49.621-48.112c18.54-18.04 43.383-28.225 69.309-28.415l89.233-.811.096.114 64.519 76.404-.185 2.088.001 158.517z",
    fill: "#f5f4f8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M305.291 302.506H159.967V185.952c.006-16.951 6.076-33.345 17.122-46.245l63.693-74.332 64.509 76.443v160.688z",
    fill: "#d5d2dc",
    fillOpacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M257.321 223.45h-23.5v20.677h23.5V223.45zm0-35.935h-23.5v20.676h23.5v-20.676zm-140.725 29.036H87.047v25.999h29.549v-25.999zm0-45.001H87.047v25.586h29.549V171.55z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M522.643 301.529H3.309v1.261h519.334v-1.261z",
    fill: "#666276"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.509 275.056c11.631 0 21.06-19.15 21.06-42.774s-9.429-42.774-21.06-42.774-21.06 19.15-21.06 42.774 9.429 42.774 21.06 42.774z",
    fill: "#d5d2dc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#666276"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.456 302.297c-8.435-50.372-.085-100.568 0-101.068l1.641.276c-.085.498-8.387 50.428 0 100.52l-1.641.272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.048 223.083l-19.044 10.14.785 1.461 19.044-10.14-.785-1.461zm-38.354 5.079l-.785 1.461 19.041 10.145.785-1.46-19.041-10.146z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.514 263.909c16.785 0 30.392-27.638 30.392-61.73s-13.607-61.73-30.392-61.73-30.392 27.638-30.392 61.73 13.607 61.73 30.392 61.73z",
    fill: "#fd5631"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#666276"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9 303.125c-12.156-72.603-.123-144.942 0-145.664l1.21.204c-.123.721-12.121 72.865 0 145.26l-1.21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.549 189.418l-27.484 14.634.579 1.078 27.484-14.634-.579-1.078zm-55.909 7.334l-.58 1.078 27.48 14.641.579-1.077-27.479-14.642z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M422.463 77.932l6.662-5.305c-5.175-.567-7.302 2.241-8.17 4.465-4.043-1.671-8.445.519-8.445.519l13.329 4.817a10.04 10.04 0 0 0-3.374-4.497h-.002zM302.07 37.079l6.662-5.305c-5.175-.567-7.302 2.241-8.17 4.465-4.043-1.671-8.445.519-8.445.519l13.329 4.817c-.673-1.788-1.844-3.348-3.376-4.497z",
    fill: "#454056"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M469.752 46.956l6.662-5.304c-5.176-.567-7.303 2.241-8.17 4.465-4.044-1.671-8.446.519-8.446.519l13.33 4.817a10.04 10.04 0 0 0-3.375-4.498l-.001.001z",
    fill: "#fd5631"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M186.547 293.215a10.11 10.11 0 0 0-5.045 1.348 10.87 10.87 0 0 0-5.562-2.652 10.89 10.89 0 0 0-6.115.797c-1.917.848-3.546 2.233-4.689 3.986s-1.75 3.797-1.748 5.887h33.255a10.06 10.06 0 0 0-3.197-6.66 10.15 10.15 0 0 0-6.898-2.706h-.001zm289.588 0a10.11 10.11 0 0 0-5.045 1.348 10.87 10.87 0 0 0-5.562-2.652 10.89 10.89 0 0 0-6.114.797 10.82 10.82 0 0 0-4.69 3.986c-1.142 1.752-1.75 3.797-1.747 5.887h33.254a10.06 10.06 0 0 0-3.197-6.661c-1.873-1.738-4.338-2.704-6.899-2.705zm-201.821-7.227h-47.238v1.517h7.367v14.41h1.523v-14.41h28.694v14.41h1.524v-14.41h8.129l.001-1.517zm.092-4.538h-47.237v1.517h47.237v-1.517zm.001-3.792h-47.238v1.517h47.238v-1.517z",
    fill: "#666276"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M499.917 279.33c10.185 0 18.442-16.77 18.442-37.457s-8.257-37.456-18.442-37.456-18.441 16.77-18.441 37.456 8.256 37.457 18.441 37.457z",
    fill: "#d5d2dc"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#666276"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M497.863 303.125c7.376-44.054.074-87.946 0-88.388l-.735.126c.074.437 7.355 44.213 0 88.141l.735.121z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.511 234.124l-.352.654 16.68 8.886.352-.654-16.68-8.886zm33.934 4.454l-16.681 8.886.352.654 16.681-8.885-.352-.655zm-70.163 47.41h-47.238v1.517h7.367v14.41h1.524v-14.41h28.694v14.41h1.524v-14.41h8.128l.001-1.517zm.093-4.538h-47.238v1.517h47.238v-1.517zm0-3.792h-47.238v1.517h47.238v-1.517z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M257.569 116.019l-5.679-13.117-11.401.203-6.916 13.076.139.175h-.05v27.2h23.892v-27.2l.015-.337zm177.565 32.831l-4.59-9.587-9.213.148-5.589 9.558.113.127h-.04v19.882h19.307v-19.882l.012-.246z",
    fill: "#f5f4f8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M213.411 97.174H79.479v1.261h133.932v-1.261zm-13.3 13.239H66.179v1.261h133.933v-1.261zm262.146 2.39h-21.831v1.261h21.831v-1.261zm0 13.239h-21.831v1.261h21.831v-1.261zM287.653 72.455h-26.492v1.261h26.492v-1.261zm0 13.239h-26.492v1.261h26.492v-1.261z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.8992d46f0e56f422de9415f2a18ed11a.svg";
export { ForwardRef as ReactComponent };